const AppConstants = {
  currentPage: 'currentPage',
  totalPages: 5,
  primaryTrack: 'primaryTrack',
  rootLocationKey: 'rootLocationKey',
  segmentId: 'segment_id',
  userEmail: 'userEmail',
};

const pageUrl = new URL(window.location.href);
const FORM_HOST = 'https://www.admissions.pathrise.com';
const BASE_PATH = '/apply';
const PAGE_CATEGORY = 'Enrollment Portal';

const SlowFormUrl = /^\/en\//.test(pageUrl.pathname)
  ? `${FORM_HOST}/l/772833/2020-07-15/7ps4g7` //  B Route
  : `${FORM_HOST}/l/772833/2020-07-14/7p1lks`; // A Route

const SlowFormCompletionUrl = `${FORM_HOST}/l/772833/2021-05-12/fmvd59`;

const TrackValues = {
  SWE: 'SWE',
  WebDev: 'Web',
  Data: 'Data',
  Design: 'Design',
  Sales: 'Sales',
  PSO: 'Product Management',
  Marketing: 'Marketing',
  ITCybersecurity: 'IT and Cybersecurity',
  FinanceBankingAccounting: 'Finance, Banking and Accounting',
  OperationsManagement: 'Operations Management',
  ProductManagement: 'Product Management',
  ProjectProgramManagement: 'Project and Program Management',
  SupplyChain: 'Supply Chain',
  StrategyConsulting: 'Strategy and Consulting',
  PeopleTalentHR: 'People, Talent and HR',
  EngineeringNonSoftware: 'Engineering Non Software',
  Other: 'Other',
};

const TrackValuesToPrimaryTrack = {
  SWE: 'SWE',
  Web: 'Web',
  Data: 'Data',
  Design: 'Design',
  PSO: 'PSO',
  Sales: 'Sales',
  'Product Management': 'PSO',
  Marketing: 'Marketing',
  'IT and Cybersecurity': 'IT and Cybersecurity',
  'Engineering Non Software': 'Engineering Non Software',
  'Finance, Banking and Accounting': 'PSO',
  'Operations Management': 'PSO',
  'Project and Program Management': 'PSO',
  'Supply Chain': 'PSO',
  'Strategy and Consulting': 'PSO',
  'People, Talent and HR': 'PSO',
  Other: 'Other',
};

const AWSConfig = {
  apiVersion: '2006-03-01',
  Bucket: 'pathrise-enrollment',
  region: 'us-east-2',
  IdentityPoolId: 'us-east-2:aa2f2c1d-bb91-44b2-aedf-161d97f21b7b',
  readACL: 'public-read',
};

const regularExpressions = {
  phoneRegex: /^(\+\d{1,2})?\s*\(?(\s*\d\s*){3}\)?[.-]?(\s*\d\s*){3}\s*[.-]?(\s*\d\s*){4}$/,
  emailRegex: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
  urlRegex: /((https?:\/\/)?(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|(https?:\/\/)?(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i,
};

export {
  AppConstants,
  AWSConfig,
  BASE_PATH,
  FORM_HOST,
  PAGE_CATEGORY,
  regularExpressions,
  SlowFormCompletionUrl,
  SlowFormUrl,
  TrackValues,
  TrackValuesToPrimaryTrack,
};
